import React from 'react';
import cx from 'clsx';
import styles from '../GameDetails.module.scss';
import { GameTileProps } from '../../modular-grid/types';
import { ShouldPreventDefaultForClick } from '../../LaunchStrategiesProvider/utils';
import { GameDetailsPropTypes } from '../GameDetails';
import GameLink from 'src/components/GameLink';

interface GameDetailsFooterProps {
  game: GameTileProps;
  buttonText: string;
  pageTitle?: string;
  onGameButtonClick: GameDetailsPropTypes['onGameButtonClick'];
}

const GameDetailsFooter: React.FC<GameDetailsFooterProps> = ({
  game,
  buttonText,
  pageTitle,
  onGameButtonClick,
}) => {
  if (!game) return null;

  const preventDefaultForGameClick = ShouldPreventDefaultForClick(
    game.integration
  );

  const handleButtonClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (preventDefaultForGameClick) e.preventDefault();
    onGameButtonClick &&
      onGameButtonClick({
        game,
        gamePosition: 1,
        sectionTitle: 'Game Details',
      });
  };

  return (
    <div className={styles.gameDetailsFooter}>
      <GameLink
        className={cx(styles.link, styles.detailsLink)}
        integration={game.integration}
        target="_blank"
        notIndexed={game.notIndexed}
        url={game.launchUrl}
        categoryAttributes={{
          title: 'game_details',
          topCategory: pageTitle,
        }}
        onClick={handleButtonClick}
      >
        {buttonText}
      </GameLink>
    </div>
  );
};

export default GameDetailsFooter;
